import {useAppDispatch} from '../../../stores/configureStore'
import {setAttribute} from '../../../stores/editor/editor.reducer'
import InputSlider from './InputSlider'
import {ImgCaption} from '../../../models/editor/imgCaption'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import ControlGroup from '../ControlGroup'
import {useTranslation} from 'react-i18next'

interface Props {
  img: ImgCaption
}

export default function CurvatureLevelController({img}: Props) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <ControlGroup title={t('Hajlítás')}>
      <InputSlider
        xMin={-20}
        xMax={20}
        xStep={1}
        x={img.curvatureLevel}
        marker={((0 - -20) / (20 - -20)) * 100}
        onDragEnd={(value: number) =>
          handleUpdatedAttributes(dispatch, img, {curvatureLevel: value})
        }
        onChange={(value: number) =>
          dispatch(setAttribute({id: img.id, data: {curvatureLevel: value}}))
        }
      />
    </ControlGroup>
  )
}
